// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".media .image[data-v-47b7c07c]{margin-top:6px}.account-picker[data-v-47b7c07c]  .dropdown-menu,.dropdown-item[data-v-47b7c07c]{min-width:280px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
